import Image from "next/image"
import { AppInterface } from "types/types"
import useSubmitStore from "stores/submit"
import { motion } from "framer-motion"
import useGlobalStore from "stores/global"
import useT from "utils/useT"
import imagePlaceholder from "utils/imagePlaceholder"
interface Props {
  app: AppInterface
}

const AppsListItem = ({ app }: Props) => {
  const t = useT()
  const isDark = useGlobalStore((state) => state.isDark)
  const submitApp = useSubmitStore((state) => state.submitApp)
  const setStep = useSubmitStore((state) => state.setStep)
  const {
    trackId,
    artworkUrl512,
    trackName,
    genres,
    description,
    formattedPrice,
  } = app
  const selectItem = () => {
    submitApp(app)
    setStep(1)
  }
  const animationToggle = useGlobalStore((state) => state.animationToggle)

  return (
    <motion.div
      key={trackId + "app-list-item-search"}
      onClick={selectItem}
      initial={animationToggle && { transform: "scale(0.8)", opacity: 0 }}
      animate={
        animationToggle && {
          transform: ["scale(0.9)", "scale(1.01)", "scale(1)"],
          opacity: 1,
        }
      }
      transition={
        animationToggle
          ? {
              duration: 0.3,
              type: "keyframes",
              ease: "easeOut",
            }
          : undefined
      }
      className="d-flex py-2"
    >
      <div className="align-self-center">
        <Image
          src={artworkUrl512 || imagePlaceholder(isDark)}
          alt="app icon"
          className="app-img"
          width={65}
          height={65}
          placeholder="blur"
          blurDataURL={imagePlaceholder(isDark)}
          unoptimized
        />
      </div>
      <div className="align-self-center mx-3 d-flex flex-column overflow-auto">
        <h3
          className="font-500 font-15 text-nowrap overflow-hidden"
          style={{ textOverflow: "ellipsis" }}
        >
          {trackName || "Loading..."}
        </h3>
        <span
          className="badge text-uppercase px-2 py-1 bg-green-dark font-9"
          style={{ width: "fit-content" }}
        >
          {genres ? genres[0] : "Loading..."}
        </span>
        <span
          className="color-theme font-11 ps-2 opacity-50 text-nowrap overflow-hidden"
          style={{ textOverflow: "ellipsis" }}
        >
          {description}
        </span>
      </div>
      <div className="align-self-center ms-auto">
        <div
          key={formattedPrice}
          className="btn btn-border btn-xs btn-full rounded-sm text-uppercase font-900 border-blue-dark color-blue-dark bg-theme"
        >
          {formattedPrice === "Free"
            ? t.previewApp.free
            : formattedPrice
            ? formattedPrice
            : "view"}
        </div>
      </div>
    </motion.div>
  )
}

export default AppsListItem
